import { Button, Card, CardActions, CardContent, CardHeader, Divider, Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import EditIcon from '@material-ui/icons/Edit';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { PayOptionEdit } from './components';
const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  actions: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > * + *': {
      marginLeft: 0
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  header: {
    fontWeight: 600
  }
}));

const PaymentOptionInfo = props => {
  const { className, ...rest } = props;
  const model = useSelector(state => state.models.pay_option);

  const classes = useStyles();

  const [openEdit, setOpenEdit] = useState(false);

  const handleEditOpen = () => {
    setOpenEdit(true);
  };

  const handleEditClose = () => {
    setOpenEdit(false);
  };

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Payment Option Info" />
      <Divider />
      <CardContent className={classes.content}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell className={classes.header}>Label</TableCell>
              <TableCell>{model.label}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Item Cost</TableCell>
              <TableCell>{model.item_cost}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
      <CardActions className={classes.actions}>
        <Button onClick={handleEditOpen}>
          <EditIcon className={classes.buttonIcon} />
          Edit
        </Button>
      </CardActions>
      <PayOptionEdit onClose={handleEditClose} open={openEdit} />
    </Card>
  );
};

PaymentOptionInfo.propTypes = {
  className: PropTypes.string,
};

export default PaymentOptionInfo;
